import React from "react";
import { connect } from "react-redux";
import * as agent from "../agent";
import { reduxForm, Field, change } from "redux-form";
import PrintLinks from "./PrintLinks";
import PrintP2PLinks from "./PrintP2PLinks";
import PrintLTLinks from "./PrintLTLinks";
import PrintLeasingLinks from "./PrintLeasingLinks";
import { MaterialMaskedTextField } from "./MaterialInput";
import transactionForm from "./TransactionForm";
import TransactionTable from "./TransactionTable";
import { normalizeMoney, formatDate } from "../utility";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import { calculateCommission,
         calculateMonthlyPayment,
         generateLeasingPayments } from "../businessLogic";
import { Dates, Masks, Transaction } from "../constants/enums";
import File from "./File";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';

const TransactionForm = connect(
    (state, props) => {
        const { sum, programType, operations } = props;
        const signOperation = operations.find(o => o.alias === Transaction.OperationSignAliases[programType]) || {};
        const { mustHaveContract, mustHaveDepartment } = signOperation;
        return {
            isAdmin: state.common.user.permissions.includes("forms-full-access"),
            mustHaveContract,
            mustHaveDepartment,
            initialValues: {
                manager: state.common.user.id,
                paymentDate: formatDate(new Date()),
                operation: signOperation._id,
                sum: normalizeMoney(`${sum}`),
                vat: 0
            },
        };
    }
)(reduxForm({ form: "transaction-form", enableReinitialize: true })(transactionForm));

class signContract extends React.Component {
    state = {
        showingModal: false,
        transactions: [],
        managersLoaded: false,
        managers: [],
        counterparties: [],
        counterpartiesLoaded: false,
        accounts: [],
        accountsLoaded: false,
        operations: [],
        operationsLoaded: false,
        receiptPrinted: false,
        printingReceipt: false
    };
    fireError = e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } });
    componentWillMount = () => {
        const { isJur } = this.props;
        agent.User.managers(isJur)
            .then(res => this.setState({ managersLoaded: true, managers: res.managers }))
            .catch(this.fireError);
        agent.Counterparty.getAll()
            .then(res => this.setState({ counterpartiesLoaded: true, counterparties: res }))
            .catch(this.fireError);
        agent.Account.getAll()
            .then(res => this.setState({ accountsLoaded: true, accounts: res }))
            .catch(this.fireError);
        agent.Operation.getAll()
            .then(res => this.setState({ operationsLoaded: true, operations: res }))
            .catch(this.fireError);
    }
    handleClick = (e) => {
        e.preventDefault();
        this.setState({ showingModal: true})
    }
    handleClose = () => this.setState({ showingModal: false})
    addTransaction = (data) => {
        const { transactions, operations } = this.state;
        const { sum,
                isPTS,
                programType,
                isLeasing,
                comission,
                chargeComission,
                firstMonthPrepay,
                firstProlongationPayment,
                firstBuyoutPayment } = this.props;

        const updTransactions = transactions.concat(data);
        this.setState({ transactions: updTransactions, receiptPrinted: false });

        const comissionOperation = operations.find(o => o.alias === "CONTRACT_COMMISSION") || {};
        const signOperation = operations.find(o => o.alias === Transaction.OperationSignAliases[programType]) || {};
        const prolongationOperation = operations.find(o => o.alias === Transaction.OperationProlongationAliases[programType]) || {};
        const buyoutOperation = operations.find(o => o.alias === "CONTRACT_BUYOUT") || {};

        const comissionTSum = updTransactions.reduce((p, n) => p + +(n.operation === comissionOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);
        const signTSum = updTransactions.reduce((p, n) => p + +(n.operation === signOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);
        const prolongationTSum = updTransactions.reduce((p, n) => p + +(n.operation === prolongationOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);
        const buyoutTSum = updTransactions.reduce((p, n) => p + +(n.operation === buyoutOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);

        const signAdded = signTSum === sum;
        const comissionNotAdded = (isPTS || isLeasing) && chargeComission && comissionTSum != comission;
        const prolongationNotAdded = firstMonthPrepay && prolongationTSum != firstProlongationPayment;
        const buyoutNotAdded = firstMonthPrepay && buyoutTSum != firstBuyoutPayment;

        const [ nextOperation, nextSum ] =
            signAdded ?
                (comissionNotAdded ?
                    [ comissionOperation._id, comission - comissionTSum ]
                    :
                    (prolongationNotAdded ?
                        [ prolongationOperation._id, firstProlongationPayment - prolongationTSum ]
                        :
                        (buyoutNotAdded ?
                            [ buyoutOperation._id, firstBuyoutPayment - buyoutTSum ]
                            :
                            [ signOperation._id, 0 ]
                        )
                    )
                )
                :
                [ signOperation._id, sum - signTSum ];

        this.props.dispatch(change("transaction-form", "sum", normalizeMoney(Math.max(nextSum, 0))));
        this.props.dispatch(change("transaction-form", "operation", nextOperation));
    }
    processTransactions = (transactions, operations, accounts = []) => {
        return transactions.map(t => {
            const fOperation = operations.find(o => o._id === t.operation) || {};
            const fAccount = accounts.find(a => a._id === t.account) || {};
            return Object.assign(
                {...t},
                {sum: {"DEBIT": 1, "CREDIT": -1}[fOperation.side] * Number(t.sum.replace(/\s/g,``))},
                {alias: fOperation.alias},
                {accountType: fAccount.type}
            );
        });
    }
    printReceipt = (e, office) => {
        e.preventDefault();
        this.setState({ printingReceipt: true })
        const { contractId, userCredentials } = this.props;

        const { accounts, operations, transactions } = this.state;
        agent.Websocket.sign(contractId, office, userCredentials, this.processTransactions(transactions, operations, accounts))
            .then(res => {
                this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: "Чек распечатан", type: "success" } });
                this.setState({ printingReceipt: false, receiptPrinted: true })
            })
            .catch((e) => {
                this.setState({ printingReceipt: false });
                this.fireError(e);
            });
    }
    deleteTransaction = (index) => {
        const { transactions } = this.state;
        this.setState({ transactions: transactions.filter((_, i) => i !== index), receiptPrinted: false })
    }

    render() {

        const { contractId,
                isPTS,
                isLeasing,
                isLT,
                comission,
                chargeComission,
                firstMonthPrepay,
                firstProlongationPayment,
                firstBuyoutPayment,
                sum,
                programType,
                isJur,
                onContractSign,
                switchTab,
                manager,
                userOfficeMoscow,
                userOfficeNewcherkassky,
                handleSubmit } = this.props;
        const { showingModal,
                transactions,
                managers,
                managersLoaded,
                counterparties,
                counterpartiesLoaded,
                printingReceipt,
                accounts,
                accountsLoaded,
                operations,
                operationsLoaded } = this.state;

        const comissionOperation = operations.find(o => o.alias === "CONTRACT_COMMISSION") || {};
        const signOperation = operations.find(o => o.alias === Transaction.OperationSignAliases[programType]) || {};
        const prolongationOperation = operations.find(o => o.alias === Transaction.OperationProlongationAliases[programType]) || {};
        const buyoutOperation = operations.find(o => o.alias === "CONTRACT_BUYOUT") || {};

        const signTransactions = transactions.filter(t => t.operation === signOperation._id);
        const signTSum = signTransactions.reduce((p, n) => p + +n.sum.replace(/\s/g,``), 0);
        const comissionTransactions = transactions.filter(t => t.operation === comissionOperation._id);
        const comissionTSum = comissionTransactions.reduce((p, n) => p + +n.sum.replace(/\s/g,``), 0);
        const prolongationTransactions = transactions.filter(t => t.operation === prolongationOperation._id);
        const prolongationTSum = prolongationTransactions.reduce((p, n) => p + +n.sum.replace(/\s/g,``), 0);
        const buyoutTransactions = transactions.filter(t => t.operation === buyoutOperation._id);
        const buyoutTSum = buyoutTransactions.reduce((p, n) => p + +n.sum.replace(/\s/g,``), 0);

        const allowedOperations = [Transaction.OperationSignAliases[programType]]
            .concat(chargeComission ? ["CONTRACT_COMMISSION"] : [])
            .concat(firstMonthPrepay ? [Transaction.OperationProlongationAliases[programType]].concat(isLeasing ? "CONTRACT_BUYOUT" : []) : []);

        const signAdded = signTSum === sum;
        const comissionAdded = (isPTS || isLeasing) && chargeComission ? comissionTSum === comission : true;
        const prolongationAdded = firstMonthPrepay ? prolongationTSum === firstProlongationPayment : true;
        const buyoutAdded = (firstMonthPrepay && isLeasing) ? buyoutTSum === firstBuyoutPayment : true;

        const submitEnabled = signAdded && comissionAdded && prolongationAdded && buyoutAdded;

        const processData = data => Object.assign({}, data, firstMonthPrepay ? {isFirstMonthProlongated: true, prolongationSum: prolongationTSum} : {});

        return (
            <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
                <form >
                    <Grid container justify="center" spacing={16}>
                        <Grid item className="common-form common-column">
                            <Field name="creationDate"
                                   component={MaterialMaskedTextField}
                                   mask={Masks.date}
                                   label="Дата подписания" />
                            <Field name="prolongationDate"
                                   component={MaterialMaskedTextField}
                                   mask={Masks.date}
                                   label="Дата пролонгации" />
                            <div className="files">
                                <File name="contractScan"
                                      desc="Загрузите скан-копию Договора"
                                      title="Скан-копии документов" />
                            </div>
                        </Grid>
                        <Grid item className="common-form common-column">
                            {
                                ({
                                    "PTS_LEASING": <PrintLeasingLinks id={contractId} isJur={isJur} />,
                                    "HOLD_LT": <PrintLTLinks id={contractId} sum={sum} manager={manager}/>,
                                    "PTS_P2P": <PrintP2PLinks id={contractId} sum={sum} />,
                                    "HOLD": <PrintLinks id={contractId} programType={programType} sum={sum} />,
                                    "PTS": <PrintLinks id={contractId} programType={programType} sum={sum} />
                                })[programType]
                            }
                        </Grid>
                    </Grid>
                    <Grid container justify="center" spacing={16}>
                        <Grid item className="common-form common-column">
                            <Button fullWidth
                                    onClick={e => {
                                        e.preventDefault();
                                        switchTab(null, 2);
                                    }}
                                    size="large"
                                    variant="contained" >Назад</Button>
                        </Grid>
                        <Grid item className="common-form common-column">
                            <Button type="submit"
                                    fullWidth
                                    onClick={this.handleClick}
                                    size="large"
                                    color="primary"
                                    variant="contained" >К транзакциям</Button>
                            <Dialog maxWidth={false} open={showingModal} onClose={this.handleClose}>
                                <Paper className="common-paper">
                                    <Grid container justify="center" spacing={16}>
                                        <Grid item className="common-column">
                                            <TransactionForm allowedOperations={allowedOperations}
                                                             addTransaction={this.addTransaction}
                                                             contractMode={true}
                                                             sum={sum}
                                                             managers={managers}
                                                             managersLoaded={managersLoaded}
                                                             accounts={accounts}
                                                             accountsLoaded={accountsLoaded}
                                                             counterparties={counterparties}
                                                             counterpartiesLoaded={counterpartiesLoaded}
                                                             operations={operations}
                                                             programType={programType}
                                                             operationsLoaded={operationsLoaded}
                                                             contractId={contractId} />
                                        </Grid>
                                        <Grid item className="maxwide-column">
                                            <Typography>*Для выдачи займа необходимо провести одну или несколько транзакций на указанную сумму {normalizeMoney(sum)} ₽</Typography>
                                            {(isPTS || isLeasing) && chargeComission && <Typography>Также необходимо удержать комиссию на сумму {normalizeMoney(comission)} ₽</Typography>}
                                            {firstMonthPrepay && <Typography>Также необходимо удержать авансовую предоплату по пролонгации на сумму {normalizeMoney(firstProlongationPayment)} ₽</Typography>}
                                            {firstMonthPrepay && isLeasing && <Typography>Также необходимо удержать оплату за выкуп ТС на сумму {normalizeMoney(firstBuyoutPayment)} ₽</Typography>}
                                            <Typography>Вы добавили {signTransactions.length} операций выдачи займа на сумму {normalizeMoney(signTSum)} ₽</Typography>
                                            {chargeComission && (isPTS || isLeasing) && <Typography>Вы добавили {comissionTransactions.length} операций удержания комиссии на сумму {normalizeMoney(comissionTSum)} ₽</Typography>}
                                            {firstMonthPrepay && <Typography>Вы добавили {prolongationTransactions.length} операций авансовой предоплаты на сумму {normalizeMoney(prolongationTSum)} ₽</Typography>}
                                            {firstMonthPrepay && isLeasing && <Typography>Вы добавили {buyoutTransactions.length} операций выкупа ТС на сумму {normalizeMoney(buyoutTSum)} ₽</Typography>}
                                            {signTSum > sum && <Typography >Сумма транзакций превышает сумму выдачи займа на {normalizeMoney(signTSum - sum)} ₽. Удалите одну или несколько транзакций выдачи займа</Typography>}
                                            {signTSum < sum && <Typography >Cумма выдачи займа превышает сумму транзакций на {normalizeMoney(sum - signTSum)} ₽. Добавьте одну или несколько транзакций выдачи займа</Typography>}
                                            {chargeComission && (isPTS || isLeasing) && chargeComission && comissionTSum > comission && <Typography>Сумма транзакций превышает сумму комиссии на {normalizeMoney(comissionTSum - comission)} ₽. Удалите одну или несколько транзакций удержания комиссии</Typography>}
                                            {chargeComission && (isPTS || isLeasing) && chargeComission && comissionTSum < comission && <Typography>Cумма комиссии превышает сумму транзакций на {normalizeMoney(comission - comissionTSum)} ₽. Добавьте одну или несколько транзакций удержания комиссии</Typography>}
                                            {firstMonthPrepay && prolongationTSum > firstProlongationPayment && <Typography >Сумма транзакций превышает сумму предоплаты на {normalizeMoney(prolongationTSum - firstProlongationPayment)} ₽. Удалите одну или несколько транзакций удержания предоплаты</Typography>}
                                            {firstMonthPrepay && prolongationTSum < firstProlongationPayment && <Typography >Cумма предоплаты превышает сумму транзакций на {normalizeMoney(firstProlongationPayment - prolongationTSum)} ₽. Добавьте одну или несколько транзакций удержания предоплаты</Typography>}
                                            {firstMonthPrepay && isLeasing && buyoutTSum > firstBuyoutPayment && <Typography >Сумма транзакций превышает сумму выкупа ТС на {normalizeMoney(buyoutTSum - firstBuyoutPayment)} ₽. Удалите одну или несколько транзакций выкупа ТС</Typography>}
                                            {firstMonthPrepay && isLeasing && buyoutTSum < firstBuyoutPayment && <Typography >Cумма выкупа ТС превышает сумму транзакций на {normalizeMoney(firstBuyoutPayment - buyoutTSum)} ₽. Добавьте одну или несколько транзакций выкупа ТС</Typography>}
                                            {submitEnabled && <Typography>Cуммы всех требуемых операций и транзакций совпадают. Выдача займа может быть проведена</Typography>}
                                            <Typography>Чтобы изменить сумму выдачи займа закройте диалоговое окно и отредактируйте Программу займа</Typography>
                                            { transactions.length > 0 ?
                                                <TransactionTable transactions={transactions}
                                                                   accounts={accounts}
                                                                   counterparties={counterparties}
                                                                   operations={operations}
                                                                   onTransactionDelete={this.deleteTransaction} />
                                                :
                                                <Typography>Необходимо добавить транзакцию</Typography>
                                            }

                                        </Grid>
                                    </Grid>
                                    {(isLeasing || isLT) && userOfficeMoscow &&
                                        <Grid container spacing={16}>
                                            <Grid item className="common-form common-column">
                                                <Button type="submit"
                                                        onClick={e => this.printReceipt(e, "MOSCOW")}
                                                        fullWidth
                                                        disabled={!submitEnabled || printingReceipt}
                                                        size="large"
                                                        color="primary"
                                                        variant="contained" >{printingReceipt ? "Ожидайте..." : "Чек | МСК" }</Button>
                                            </Grid>
                                        </Grid>
                                    }
                                    {(isLeasing || isLT) && userOfficeNewcherkassky &&
                                        <Grid container spacing={16}>
                                            <Grid item className="common-form common-column">
                                                <Button type="submit"
                                                        onClick={e => this.printReceipt(e, "NEWCHERKASSKY")}
                                                        fullWidth
                                                        disabled={!submitEnabled || printingReceipt}
                                                        size="large"
                                                        color="primary"
                                                        variant="contained" >{printingReceipt ? "Ожидайте..." : "Чек | НВЧ" }</Button>
                                            </Grid>
                                        </Grid>
                                    }
                                    <Grid container spacing={16}>
                                        <Grid item className="common-form common-column">
                                            <Button type="submit"
                                                    onClick={handleSubmit(data => {
                                                            onContractSign(contractId, processData(data), this.processTransactions(transactions, operations) );
                                                            this.handleClose();
                                                        })
                                                    }
                                                    fullWidth
                                                    disabled={!submitEnabled}
                                                    size="large"
                                                    color="primary"
                                                    variant="contained" >Займ выдан</Button>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Dialog>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        );
    }
}

const SignContract = connect(
    (state, props) => {
        const { programDetails: { programType, sum, duration, rates = [], chargeComission, preferentialPeriod, preferentialRepayment, isLeasingPrepayed } = {} } = props;
        const isPTS = programType === "PTS" || programType === "PTS_P2P";
        const isLeasing = programType === "PTS_LEASING";
        const isLT = programType === "HOLD_LT";
        const comission = calculateCommission(sum);

        const paymentsPlan = generateLeasingPayments({
            date: new Date(),
            duration,
            leasingRate: rates[0],
            sum,
            preferentialPeriod,
            isLeasingPrepayed: isLeasingPrepayed,
            isPreferentialRepayment: preferentialRepayment
        });

        const firstProlongationPayment = isLeasing ? paymentsPlan[0].paymentTotal - paymentsPlan[0].paymentCar : calculateMonthlyPayment(sum, rates[0]);
        const firstBuyoutPayment = paymentsPlan[0].paymentCar;
        const firstMonthPrepay = isPTS || (isLeasing && isLeasingPrepayed);

        const [
            secondname = "",
            firstname = "",
            thirdname = ""
        ] = state.common.user.fullname.split(" ");

        return {
            userOfficeMoscow: state.common.user.officeMoscow,
            userOfficeNewcherkassky: state.common.user.officeNewcherkassky,
            userCredentials: `${secondname} ${firstname[0]}. ${thirdname[0]}.`,
            managers: state.users.managers,
            manager: state.common.user.id,
            firstMonthPrepay,
            firstProlongationPayment,
            firstBuyoutPayment,
            isPTS,
            isLeasing,
            isLT,
            sum,
            programType,
            chargeComission,
            comission,
            initialValues: {
                creationDate: formatDate(new Date()),
                prolongationDate: formatDate(new Date(+new Date() + (isLT ? 0 : Dates._30Days)))
            },
        };
    },
    null
)(reduxForm({
    form: "sign-contract-form",
    enableReinitialize: true,
})(signContract));

export default SignContract;



// WEBPACK FOOTER //
// ./src/components/SignContract.js